// extracted by mini-css-extract-plugin
export var equalColumn = "_ij-0";